/**
 * @generated SignedSource<<d566303f310e8eec7f148c9ad7039ee4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ArtifactType = "ANNOTATION" | "BUILDS" | "BUILD_LOGS" | "CAPABILITY" | "CHANNEL" | "CLI_OUTPUT" | "COMMITS" | "DASHBOARDS" | "DATA" | "DATAFRAMES" | "DOCUMENTS" | "EVENTS" | "ISSUES" | "LOGS" | "MEMORIES" | "METRICS" | "MONITORS" | "SPANS" | "TABLE" | "THREADS" | "TRACES" | "WEB" | "WORKFLOWS" | "%future added value";
export type ArtifactCardQuery$variables = {
  artifactId: string;
};
export type ArtifactCardQuery$data = {
  readonly artifact: {
    readonly artifactType: ArtifactType;
    readonly id: any;
    readonly value: any;
  } | null | undefined;
};
export type ArtifactCardQuery = {
  response: ArtifactCardQuery$data;
  variables: ArtifactCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "artifactId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "artifactId",
        "variableName": "artifactId"
      }
    ],
    "concreteType": "GraphQLArtifact",
    "kind": "LinkedField",
    "name": "artifact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "artifactType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtifactCardQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArtifactCardQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "022ebb43ccb9f91c5ed939b657a4990a",
    "id": null,
    "metadata": {},
    "name": "ArtifactCardQuery",
    "operationKind": "query",
    "text": "query ArtifactCardQuery(\n  $artifactId: String!\n) {\n  artifact(artifactId: $artifactId) {\n    id\n    artifactType\n    value\n  }\n}\n"
  }
};
})();

(node as any).hash = "90706f7c6192b9e9ce8e44d83be20416";

export default node;
